<template>
    <div id="myinfo-gender">
      <f7-list form class="form-group">
        <f7-list-input
          input-id      ="gender"
          id            ="genderInput"
          name          ="gender"

          class         ="clickable-row use-chevron"
          placeholder   =""
          :value        ="gender"
          :label        ="$t('regis-gender')"
          autocomplete  ="off"
          v-show        ="isShow"
          outline
          floating-label
          required
          :disabled    = "isDisabled"
        >
          <f7-link popover-open=".popover-dropdown-gender" slot="content-start" class="clickable-item"></f7-link>
        </f7-list-input>

        <f7-popover id="dropdownGender" class="popover-dropdown-gender dropdown-default dropdown myinfo" :backdrop="true">
          <f7-list>
            <f7-list-item popover-close link="#" @click="onInput('gender','M');">{{$t('regis-male')}}</f7-list-item>
            <f7-list-item popover-close link="#" @click="onInput('gender','F');">{{$t('regis-female')}}</f7-list-item>
          </f7-list>
        </f7-popover>

    </f7-list>
    </div>
</template>

<script>
  import { mapGetters, mapActions } from "vuex";
  export default {
    props: {
      isShow:{
        type: Boolean
      },
      isDisabled:{
        type: Boolean
      },
    },
    mounted (){
      this.renderDropdown();
    },
    data: function () {
      return {
      }
    },
    computed: {
      ...mapGetters('myinfo', [
          'gender'
      ])
    },
    methods: {
      ...mapActions('myinfo', [
          'setGender',
          'validateInput',
      ]),

      async renderDropdown(){
        const self    = this;
        const popover = ".myinfo.popover-dropdown-gender";
        const popoverInner = ".myinfo.popover-dropdown-gender .popover-inner";
        const popoverId = "dropdownGender";
        const inputId = "gender";
        const inputListId = "#genderInput";
        await self.setDropdownDirection(popover, popoverInner, popoverId, inputId, inputListId)
      },

      async onInput(id, val){
        await this.setGender(val);
        await this.validateInput({id: id, value: val});
        this.validateNextButton()
      },

      validateNextButton(){
        this.$emit("validateNextButton");
      }

    }
  }
</script>